import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { PageUrlsShellComponent } from './common/components/page-urls/page-urls-shell.component';
import { AuthDeflectionComponent } from './common/components/auth-deflection/auth-deflection.component';

const routes: Routes = [
  {
    path: 'help/how-to/auth-deflection',
    component: AuthDeflectionComponent,
  },
  {
    path: 'help/how-to/~dashboard',
    loadChildren: () => import('./seo-dashboard/seo-dashboard.module').then((m) => m.SEODashboardModule),
  },
  {
    path: 'help/how-to/.scully-config/seo-landing-page-urls',
    component: PageUrlsShellComponent,
  },
  {
    path: 'help/how-to/guides',
    loadChildren: () => import('./seo-flow/seo-flow.module').then((m) => m.SEOFlowModule),
  },
  {
    path: 'help/how-to',
    children: [
      {
        path: 'billing-and-payment/view-bill',
        loadComponent: () => import('./billing/view-bill/view-bill.component').then((mod) => mod.ViewBillComponent),
      },
      {
        path: 'billing-and-payment/make-a-payment',
        loadChildren: () =>
          import('./billing/seo-make-a-payment/seo-make-a-payment.module').then((m) => m.SeoMakeAPaymentModule),
      },
      {
        path: '',
        loadChildren: () => import('./seo-landing-page/seo-landing-page.module').then((m) => m.SEOLandingPageModule),
      },
      {
        path: '**',
        loadChildren: () =>
          import('@challenger/care/components/page-not-found/page-not-found.module').then((m) => m.PageNotFoundModule),
      },
    ],
  },
  {
    path: 'v1',
    children: [
      {
        path: '',
        loadChildren: () => import('./seo-landing-page/seo-landing-page.module').then((m) => m.SEOLandingPageModule),
      },
      {
        path: '**',
        loadChildren: () =>
          import('@challenger/care/components/page-not-found/page-not-found.module').then((m) => m.PageNotFoundModule),
      },
    ],
  },
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: () => import('./seo-landing-page/seo-landing-page.module').then((m) => m.SEOLandingPageModule),
      },
      {
        path: '**',
        loadChildren: () =>
          import('@challenger/care/components/page-not-found/page-not-found.module').then((m) => m.PageNotFoundModule),
      },
    ],
  },
  {
    path: '**',
    loadChildren: () =>
      import('@challenger/care/components/page-not-found/page-not-found.module').then((m) => m.PageNotFoundModule),
  },
];

const routerOptions: ExtraOptions = {
  initialNavigation: 'enabledBlocking',
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  // preloadingStrategy: PreloadAllModules, // if you have large microapp, add custom strategy to optimise preload
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
